import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';
import { Heading, Text } from '../..';
import { EventSeriesData, VenueId } from '@beat-venues/common-types';

export interface EventDetailProps
    extends CommonProps,
        VariantProps<typeof EventDetailStyles>,
        Pick<EventSeriesData, 'name' | 'tourName'> {
    venueId: VenueId;
    venueName: string;
    date?: string;
    backButton?: ReactElement;
}

export const EventDetailStyles = cva('');

export const EventDetail = ({
    className,
    venueId,
    venueName,
    name,
    tourName,
    date,
    backButton,
    testId = 'event-detail',
    ...props
}: EventDetailProps): JSX.Element => {
    const textColorClassNames = {
        beat: 'text-bt-brand-500 ',
        sportpaleis: 'text-as-brand-500',
        'afas-dome': 'text-ad-brand-500',
        'lotto-arena': 'text-la-brand-500',
        'forest-national': 'text-vn-brand-500',
        'trixxo-arena': 'text-ta-brand-500',
        'stadsschouwburg-antwerp': 'text-sa-brand-500',
        'capitole-ghent': 'text-cg-brand-500',
        'trixxo-theater': 'text-tt-brand-500',
        'beat-tickets': 'text-bt-brand-500',
        'channel-business': 'text-bt-brand-500',
        'channel-corporate': 'text-bt-brand-500',
    };

    const textColorClassName = textColorClassNames[venueId];

    return (
        <div
            className={twMerge(EventDetailStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            <div>
                {backButton && backButton}
                <Heading
                    as="h4"
                    className="mb-0 line-clamp-2 drop-shadow lg:mb-1.5"
                >
                    {name}
                </Heading>
                {tourName && (
                    <Heading as="h5" className="mb-1 text-lg font-normal">
                        {tourName}
                    </Heading>
                )}
                <Text className={`${textColorClassName} uppercase`}>
                    {venueName}
                </Text>
                {date && (
                    <Text className="mb-0 block lg:font-normal">{date}</Text>
                )}
            </div>
        </div>
    );
};
